var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftMenu2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19.659mm",
    height: "10mm",
    viewBox: "0 0 19.659 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.168 338.1h55.728v28.346h-55.728z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.53 -118.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 96.823 247.78)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath790)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43.875 363.9c-5.6282 0-10.207-4.5788-10.207-10.207s4.5788-10.207 10.207-10.207c5.628 0 10.207 4.5788 10.207 10.207s-4.5788 10.207-10.207 10.207m0-22.959c-7.0315 0-12.752 5.7206-12.752 12.752s5.7206 12.752 12.752 12.752 12.752-5.7206 12.752-12.752-5.7204-12.752-12.752-12.752",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.334 357.23c-1.6785 0-3.2564-0.4362-4.629-1.1989 0.12733-0.7582 0.19464-1.5364 0.19464-2.3302 0-0.0207-6.5e-4 -0.0411-8.1e-4 -0.0617 1.2395 0.9229 2.7745 1.4701 4.4351 1.4701 4.103 0 7.441-3.338 7.441-7.4411 0-4.103-3.338-7.441-7.441-7.441-3.3386 0-6.1706 2.2103-7.1098 5.2445-0.47099-0.6479-0.99585-1.2538-1.5683-1.8113 1.5189-3.2756 4.8364-5.5538 8.678-5.5538 5.2724 0 9.5618 4.2892 9.5618 9.5616s-4.2894 9.5618-9.5618 9.5618",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.742 345.18c-1.0253-2.8843-3.781-4.9556-7.0127-4.9556-4.1028 0-7.4408 3.338-7.4408 7.441 0 4.1031 3.338 7.4411 7.4408 7.4411 1.5243 0 2.9424-0.4614 4.1235-1.2507 0.0087 0.7922 0.08236 1.5689 0.21794 2.3247-1.3039 0.6674-2.7787 1.0466-4.3414 1.0466-5.2721 0-9.5615-4.2893-9.5615-9.5617 0-5.2723 4.2894-9.5616 9.5615-9.5616 3.7609 0 7.0201 2.1832 8.5806 5.3481-0.56887 0.5315-1.0936 1.1094-1.568 1.7281",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.77 353.98c0-0.937-0.75963-1.6966-1.6966-1.6966-0.93712 0-1.6968 0.7596-1.6968 1.6966 0 0.9369 0.75963 1.6965 1.6968 1.6965 0.93696 0 1.6966-0.7596 1.6966-1.6965",
    fill: "#70bde5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1618 0 0 .1618 37.26 357.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.94-8.797",
    fill: "none",
    stroke: "#175583",
    strokeMiterlimit: 10,
    strokeWidth: 3.932
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1618 0 0 .1618 50.278 357.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.94-8.797",
    fill: "none",
    stroke: "#175583",
    strokeMiterlimit: 10,
    strokeWidth: 3.932
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.848 349.15-0.67032 0.5488 0.64573 1.7575 0.28735 0.9777 0.15775 0.9905-0.08106 0.8129 0.98808 0.124 0.14691-1.4731-0.41209-1.529-0.39155-1.2189z",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.197 346.81c-0.46322-0.8145-1.4992-1.0992-2.3137-0.6358-0.81447 0.4632-1.0992 1.499-0.63585 2.3135 0.46322 0.8144 1.4992 1.0992 2.3137 0.636 0.81448-0.4634 1.0991-1.4992 0.63586-2.3137",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.745 349.04 5.4575 2.5853-3.1646-5.0524z",
    fill: "#a1c74a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#175583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.659 350.53h-0.20548c-0.1817 0-0.33039 0.1487-0.33039 0.3305v2.3171c0 0.1819 0.14869 0.3305 0.33039 0.3305h0.20548c0.18169 0 0.33055-0.1486 0.33055-0.3305v-2.3171c0-0.1818-0.14886-0.3305-0.33055-0.3305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.659 341.65h-0.20548c-0.1817 0-0.33039 0.1487-0.33039 0.3306v2.317c0 0.1819 0.14869 0.3306 0.33039 0.3306h0.20548c0.18169 0 0.33055-0.1487 0.33055-0.3306v-2.317c0-0.1819-0.14886-0.3306-0.33055-0.3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.508 347.8v0.2055c0 0.1816 0.14869 0.3303 0.33055 0.3303h2.3171c0.18185 0 0.33054-0.1487 0.33054-0.3303v-0.2055c0-0.1817-0.14869-0.3306-0.33054-0.3306h-2.3171c-0.18186 0-0.33055 0.1489-0.33055 0.3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.627 347.8v0.2055c0 0.1816 0.14869 0.3303 0.33054 0.3303h2.3171c0.18185 0 0.33054-0.1487 0.33054-0.3303v-0.2055c0-0.1817-0.14869-0.3306-0.33054-0.3306h-2.3171c-0.18185 0-0.33054 0.1489-0.33054 0.3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.054 348.41c0.36226 0.8642 1.3563 1.2713 2.2206 0.909 0.86415-0.3621 1.2711-1.3563 0.90897-2.2205-0.36226-0.8643-1.3563-1.2712-2.2206-0.9091-0.86414 0.3622-1.2712 1.3565-0.90896 2.2206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.755 346.49-5.1077-3.2217 2.5353 5.3957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.73 350.53h-0.20548c-0.1817 0-0.33039 0.1487-0.33039 0.3305v2.3171c0 0.1819 0.14869 0.3305 0.33039 0.3305h0.20548c0.18169 0 0.33054-0.1486 0.33054-0.3305v-2.3171c0-0.1818-0.14885-0.3305-0.33054-0.3305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.73 341.65h-0.20548c-0.1817 0-0.33039 0.1487-0.33039 0.3306v2.317c0 0.1819 0.14869 0.3306 0.33039 0.3306h0.20548c0.18169 0 0.33054-0.1487 0.33054-0.3306v-2.317c0-0.1819-0.14885-0.3306-0.33054-0.3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.578 347.8v0.2055c0 0.1816 0.14869 0.3303 0.33054 0.3303h2.3171c0.18185 0 0.33054-0.1487 0.33054-0.3303v-0.2055c0-0.1817-0.14869-0.3306-0.33054-0.3306h-2.3171c-0.18185 0-0.33054 0.1489-0.33054 0.3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.698 347.8v0.2055c0 0.1816 0.14869 0.3303 0.33054 0.3303h2.3171c0.18186 0 0.33055-0.1487 0.33055-0.3303v-0.2055c0-0.1817-0.14869-0.3306-0.33055-0.3306h-2.3171c-0.18185 0-0.33054 0.1489-0.33054 0.3306"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1618 0 0 .1618 39.048 349.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.384 6.574-8.621 14.972-8.621 24.113 0 21.02 17.101 38.12 38.12 38.12 21.018 0 38.119-17.1 38.119-38.12 0-8.927-3.093-17.141-8.253-23.644l6.759-6.759c6.863 8.254 10.998 18.854 10.998 30.403 0 26.26-21.363 47.625-47.623 47.625s-47.624-21.365-47.624-47.625c0-11.761 4.295-22.533 11.387-30.851z",
    fill: "none",
    stroke: "#175583",
    strokeMiterlimit: 10,
    strokeWidth: 5.243
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.54 354.71 3.4655 4.9456-0.25272-5.9563z",
    fill: "#70bde5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMenu2);
export default __webpack_public_path__ + "static/media/left-menu-2.111c047887da6c334e6c451deba367cb.svg";
export { ForwardRef as ReactComponent };